import styled from 'styled-components'

export const CenterBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`

export const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
`
